var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTunningCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 610,
    height: 610,
    viewBox: "0 0 610 610",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 305,
    r: 277,
    stroke: "url(#paint0_radial_3908_46085)",
    strokeWidth: 56,
    strokeLinejoin: "round",
    strokeDasharray: "10 10"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3908_46085",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.1405 384.245) rotate(-26.1361) scale(522.951)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176541,
    stopColor: "#3360AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469807,
    stopColor: "#DFEBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDE9FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTunningCircle);
export default __webpack_public_path__ + "static/media/tunning-circle.c5a78b998c445fc45da90a9480dbea5e.svg";
export { ForwardRef as ReactComponent };